import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allMicrowaves } from 'app/mocks/data/machines/microwaves'

import { api } from 'app/utils/constants'

import { Microwave } from 'app/types/machines/microwave'

export const getMicrowave = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.machines.microwaves.DETAILS}`,
    ({ params }) => {
        const { id } = params

        const microwaveFound = allMicrowaves.find(
            (machine) => machine.id.toString() === id,
        )

        // Not found
        if (!microwaveFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json<Microwave>(microwaveFound)
    },
)
